import { SiteInfo } from '@sitecore-jss/sitecore-jss-nextjs/site';
import { loadRuntimeConfig } from 'lib/runtime-config/loadRuntimeConfig';
import { SiteResolverPlugin } from '..';

class MultisitePlugin implements SiteResolverPlugin {
  exec(sites: SiteInfo[]): SiteInfo[] {
    const config = loadRuntimeConfig();

    // Add preloaded sites
    sites.push(...(JSON.parse(config.sites || '[]') as SiteInfo[]));

    return sites;
  }
}

export const multisitePlugin = new MultisitePlugin();
